import { FormikValues, useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import { useEffect, FC, useCallback } from 'react';

interface PropertyPalAutoSaveProps {
  delay?: number;
  onSubmit?: (v: FormikValues) => void;
}

const PropertyPalAutoSave: FC<PropertyPalAutoSaveProps> = ({ delay = 300, onSubmit }) => {
  const { values, errors, initialValues } = useFormikContext<FormikValues>();

  // The PropertyPalForm will require `enableReinitialize` for this to work
  // enableReinitialize allows the initialValues to update
  // so it compares the current values to the last update
  // and not against the actual initialised values passed into the form
  const isSameValueAsInitialValue = async (v: FormikValues) => isEqual(v, initialValues);

  const onFormSubmit = useCallback(async () => {
    // only return values that have no errors
    const v: FormikValues = omit(values, Object.keys(errors));
    // if onSubmit function prop is passed call it and pass valid form values into it
    if (onSubmit && !(await isSameValueAsInitialValue(v))) onSubmit(v);
  }, [values, initialValues, errors]);

  // add delay of 300ms by default, or whatever delay prop is
  useEffect(() => {
    const timer = setTimeout(() => onFormSubmit(), delay);
    return () => clearTimeout(timer);
  }, [values, errors]);

  return null;
};

export default PropertyPalAutoSave;
